import { TFunction } from 'i18next';
import { TableColumn, TableStyles } from 'react-data-table-component';
import { NavigateFunction } from 'react-router';
import { WfUser } from 'src/api/wf/models/WfUser';
import { WfScreensMap } from 'src/ui/wf/router/WfScreensMap';
import { wfNavigate } from 'src/ui/wf/router/WfScreenRegistration';
import { WF_Screen } from 'src/ui/wf/router/WfScreens';
import LinkButton from '../../common/button/LinkButton';

export const userTableStyle: TableStyles = {
  table: { style: { border: '1px solid #e3e6e7' } },
  headRow: {
    style: { minHeight: 30, backgroundColor: '#f2f3f3' },
  },
  headCells: {
    style: { borderBottom: '1px solid #e3e6e7', borderRight: '1px solid #e3e6e7', fontWeight: 700 },
  },
  rows: {
    style: {
      minHeight: 30,
    },
  },
};

export const userColumns = (
  navigate: NavigateFunction,
  t: TFunction<'translation', undefined>,
  setSelectedUser: (user: WfUser | null) => void
): TableColumn<WfUser>[] => {
  return [
    {
      name: t('wf.userSearch.userName'),
      cell: (row) => (
        <LinkButton
          title={row.name}
          onClick={() => {
            setSelectedUser(row.ldapId ? row : null);
            wfNavigate(navigate, WfScreensMap[WF_Screen.PropertiesList].path, true);
          }}
        />
      ),
      grow: 1,
    },
    {
      name: t('wf.userSearch.ldapId'),
      cell: (row) => <div className="items-start ps-2">{row.ldapId}</div>,
      grow: 1,
    },
    {
      name: t('wf.userSearch.phoneNo'),
      cell: (row) => <div className="items-start ps-2">{row.telephoneNumber}</div>,
      grow: 1,
    },
    {
      name: t('wf.userSearch.organizationCode'),
      cell: (row) => <div className="items-start ps-2">{row.organizationCode}</div>,
      grow: 2,
    },
    {
      name: t('wf.userSearch.position'),
      cell: (row) => <div className="items-start ps-2">{row.positionName}</div>,
      grow: 1,
    },
  ];
};
